
const listingsReducer = (state, action) => {
    switch (action.type) {
        case 'update-listing':
            var listings = [...state].map(listing => {
                if (listing.Id == action.payload.Id) {
                    return {
                        ...listing,
                        ...action.payload
                    };
                } else {
                    return listing;
                }
            });
            return listings;
        case 'update-listings':
            return action.payload;
        case 'update-auction-bidding-data':
            return [...state].map(listing => {
                let biddingData = action.payload.find(result => result.ListingID === listing.Id) || listing.AuctionBiddingData || {};
                return { ...listing, AuctionBiddingData: biddingData };
            });
        default:
            return state;
    }
};



export default listingsReducer;